import { render, staticRenderFns } from "./OtherPaymentForm.vue?vue&type=template&id=33f27aab&scoped=true"
import script from "./OtherPaymentForm.vue?vue&type=script&lang=js"
export * from "./OtherPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f27aab",
  null
  
)

export default component.exports